import { Input as CoreInput } from '@eleo-rh/core-ui'
import type { InputRef } from 'antd'
import { useI18n } from 'context/I18nProvider'
import type * as React from 'react'
import { useLocation } from 'react-router-dom'

type BaseInputProps = React.ComponentProps<typeof CoreInput.Search>

type SearchInputProps = Omit<BaseInputProps, 'onChange'> & {
  onChange: (txt: string) => void
  minCharSearch?: number
  ref?: React.Ref<InputRef>
}

const SearchInput = ({ ref, ...props }: SearchInputProps) => {
  const { onChange, value, defaultValue, minCharSearch = 0, ...rest } = props
  const { i18n } = useI18n()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const search = searchParams.get('q')
  const resolvedDefaultValue = defaultValue ?? search ?? ''

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value)
  }

  return (
    <CoreInput.Search
      ref={ref}
      value={value}
      defaultValue={resolvedDefaultValue}
      onChange={handleChange}
      onSearch={onChange}
      debounceTime={300}
      minCharSearch={minCharSearch}
      placeholder={i18n('label.searchplaceholder')}
      allowClear
      size="medium"
      {...rest}
    />
  )
}
export default SearchInput
